import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Page } from './Page';
import {
  Form,
  PasswordField,
  FormButton,
  FormError,
} from '../../../components/shared';
import { LogoExtendedIcon } from '../../../icons';

export type FormData = {
  accessCode: string;
};

export type PasswordStepProps = {
  onSubmit: (data: FormData) => void | Promise<void>;
};

export const PasswordStep: React.FC<PasswordStepProps> = ({ onSubmit }) => {
  const { t } = useTranslation(['forms']);

  return (
    <Page>
      <Stack py={36} spacing={24} align="center">
        <LogoExtendedIcon color="black" width={192} height={96} />
        <Stack spacing={8} align="center">
          <Text fw={600} fz="lg">
            {t('external.passwordLine1')}
          </Text>
          <Text fw={500} fz="md">
            {t('external.passwordLine2')}
          </Text>
        </Stack>

        <Form onSubmit={onSubmit}>
          <Stack>
            <FormError />
            <Stack spacing={0} align="center">
              <PasswordField name="accessCode" w={327} />
              <FormButton type="submit">{t('external.passwordCta')}</FormButton>
            </Stack>
          </Stack>
        </Form>
      </Stack>
    </Page>
  );
};
